import { trans } from '@spotahome/soyuz/client';

import Section from '@spotahome/ui-library/src/tenant/components/LandingSection/LandingSection';

import { HOW_IT_WORKS_STEPS } from '../../constants/howItWorks';

import HiwStepItem from './HiwStepItem';

import './HiwStepsDesktop.scss';

const HiwStepsDesktop = () => {
  return (
    <Section containerClassName="hiw-steps-desktop">
      <h2 className="hiw-steps-desktop__title">
        {trans('how_it_works.steps.title')}
      </h2>
      {HOW_IT_WORKS_STEPS.map(
        (
          { titleKey, descriptionKey, bulletPoints, renderImage, cta },
          index
        ) => (
          <HiwStepItem
            stepNumber={index + 1}
            key={titleKey}
            titleKey={titleKey}
            descriptionKey={descriptionKey}
            bulletPoints={bulletPoints}
            renderImage={renderImage}
            cta={cta}
          />
        )
      )}
    </Section>
  );
};

export default HiwStepsDesktop;
